import { useNavigate } from '@tanstack/react-router'
import { CirclePlusIcon } from 'lucide-react'

import { useCreateClientMarketItchConnection } from '@/gen/publicApi'

import { DropdownMenuItem } from '@/components/dropdown-menu'
import { useToast } from '@/components/toast/useToast'

interface Props {
    clientCode: string
    marketCode: string
}

export default function NewItchConnectionMenuItem({ clientCode, marketCode }: Props) {
    const { toast } = useToast()
    const navigate = useNavigate()
    const createConnectionMutator = useCreateClientMarketItchConnection(clientCode, marketCode, {
        mutation: {
            onSuccess: ({ id }) => {
                navigate({
                    to: `/$client_code/markets/$market_code/connections/itch/$connection_id`,
                    params: {
                        client_code: clientCode,
                        market_code: marketCode,
                        connection_id: id,
                    },
                })
                toast({
                    title: 'New ITCH connection created',
                })
            },
            onError: error => {
                console.error('Error creating market', error)
                toast({
                    variant: 'destructive',
                    title: 'Error creating ITCH connection for market',
                })
            },
        },
    })
    return (
        <DropdownMenuItem className="flex" onSelect={() => createConnectionMutator.mutate(undefined as never)}>
            <CirclePlusIcon className="w-4 h-4 mr-2" /> New ITCH Connection
        </DropdownMenuItem>
    )
}
